var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("project-recommendations", {
    attrs: {
      quantity: 12,
      "exclude-project-ids": [],
      "extra-large-screen-visible-items-count":
        _vm.extraLargeScreenVisibleItemsCount,
      source: "backer-center",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }